// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useNavigate, useParams } from 'react-router-dom';
import { taskListData } from '../../store/slices/task/taskSlice';
import { format } from 'date-fns';
import { ExclamationIcon } from '../../components/icons/Icons';

function ApplicationTasks() {
  const [taskList, setTaskList] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const { base_slug, jobId, appId } = useParams();
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await dispatch(taskListData({ appId })).unwrap();
        setTaskList(res);
      } catch (error) {
        console.error('Error fetching task data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, base_slug, jobId, appId]);

  // Format date function to display date in readable format
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return format(date, 'dd MMM yyyy');
    } catch (error) {
      return dateString;
    }
  };

  // Function to capitalize first letter of a string
  const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleNavigate = (data) => {
    if (data.type === 'questionnaire') {
      if (data.task_status === 'pending') {
        navigate(`/${base_slug}/${jobId}/app/${appId}/tasks/questionnaire/${data.type_id}`)
      }
    }
    if (data.type === 'meeting') {
      navigate(`/${base_slug}/${jobId}/app/${appId}/tasks/meeting/${data.type_id}`)
    }

  }

  return (
    <div className="mt-0 px-4 lg:px-2 py-4 lg:py-8 h-[calc(100vh_-_115px)]">
    <div className="w-full max-w-[710px] mx-auto">
      <h2 className='text-[16px] lg:text-lg font-medium text-gray-900'>Tasks</h2>
      <div className='bg-[#e0e0e0] w-full h-[1px] mt-4 mb-5 lg:mb-8 lg:mt-7'></div>

      {loading ? (
        <div className="flex items-center justify-center h-[calc(100vh_-_380px)] w-full">
          <div className="simple-spinner-loader">
            <span></span>
          </div>
        </div>
      ) : taskList && taskList.length > 0 ? (


















        
  <div className="bg-white rounded-lg overflow-hidden border border-solid border-[#0009321f]">

          {/* Header Row */}
          <div className="grid grid-cols-10 gap-4 px-6 py-3 bg-[#00005506] border-b border-gray-200">
            <div className="col-span-3 font-semibold text-[#1c2024] text-sm">  Title</div>
            <div className="col-span-3 font-semibold text-[#1c2024] text-sm"> Type</div>
            <div className="col-span-2 font-semibold text-[#1c2024] text-sm">Status</div>
            <div className="col-span-2 font-medium text-gray-500 text-sm">Date</div>
          </div>
          
          {/* Scrollable table body */}
          <div className="overflow-y-auto max-h-[calc(100vh_-_250px)]">
            <table className="min-w-full">
              <tbody>
                {taskList.map((task) => (
                  <tr 
                    key={task.id} 
                    onClick={() => handleNavigate(task)} 
                   className="grid grid-cols-10 gap-4 px-6 py-4  border-b border-[#0009321f] last-of-type:border-b-0"
                  >
                    <td className="col-span-3 flex items-center">
                      <p className="text-dark-black-100 overflow-hidden text-ellipsis line-clamp-1  text-[13px] capitalize">
                        {task.title}
                      </p>
                    </td>
                    <td className="col-span-3 flex items-center">
                      <p className="text-dark-black-100 overflow-hidden text-ellipsis line-clamp-1  text-[13px] capitalize">
                        {capitalizeFirstLetter(task.type)}
                      </p>
                    </td>
                    <td className="col-span-2 flex items-center">
                      <span className={`flex items-center gap-[6px]  text-[13px] capitalize  rounded-md px-2 py-1  text-xs font-medium  ring-1 ring-inset ring-gray-500/10 ${
                        task.task_status === 'pending'
                          ? 'bg-yellow-100 text-yellow-800'
                          : task.task_status === 'completed' || task.task_status === 'done'
                            ? 'bg-green-100 text-green-800'
                            : 'bg-gray-100 text-gray-800'
                        }`}
                      >
                        {capitalizeFirstLetter(task.task_status)}
                      </span>
                    </td>
                    <td className="col-span-2 flex items-center">
                      <p className="text-dark-black-100 overflow-hidden text-ellipsis line-clamp-1  text-[13px] capitalize">
                        {formatDate(task.created_at)}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
       
         <div className='w-full mt-0 flex justify-center items-center flex-col gap-y-3 bg-white' style={{ height: 'calc(69vh - 144px)' }}>
                                    <ExclamationIcon />
                                    <p className='text-[#0000007a] text-[13px]'>
                                     No tasks found
                                    </p>
                                  </div>
      )}
    </div>
  </div>
  );
}

export default ApplicationTasks;